/**
 * LoadingSpinner Component
 * Centered circular progress indicator for loading states
 */

import React from 'react';
import { Box, CircularProgress } from '@mui/material';

/**
 * LoadingSpinner component
 * Displays a centered spinner with optional overlay
 * @param {number} size - Size of the spinner in pixels (default: 50)
 */
const LoadingSpinner = ({ size = 50 }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '400px',
      width: '100%',
    }}
  >
    <CircularProgress size={size} sx={{ color: '#B71C1C' }} />
  </Box>
);

export default LoadingSpinner;
